import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from '../api-base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MembershipApiService {

  private apiDomain = environment.API_URL_CORE;

  constructor(private apiBaseService:ApiBaseService,
    private http: HttpClient
  ) { }

  public getMembershipExpiration(customerId:string):Observable<any>{
    return this.apiBaseService.create("/api/membership/"+customerId+"/status", [], null);
  }

  getLicenseSerials(customerId: string, productCode: string) {
  return this.apiBaseService.get(
    `/api/membership/${customerId}/licenses/byCode/${productCode}`,
    null,
    null
  );
}

  getDownloadUrl(fileName: string): Observable<string> {
      return this.http.get<any>(
        `${this.apiDomain}/api/membership/get-download-url/`,
        { params: { fileName } }
      ).pipe(map(res => res.url));
    }

}
